// Tin Validation: https://phpfashion.com/cs/jak-overit-platne-ic-a-rodne-cislo

import { Country } from '@/app/enums';
import { getCountryConfig } from '@/app/utils/countryConfig';

export function isValidCZ(companyId: string): boolean {
  companyId = companyId.replace(/\s+/g, '');
  if (!/^\d{8}$/.test(companyId)) {
    return false;
  }

  let a = 0;
  for (let i = 0; i < 7; i++) {
    a += parseInt(companyId[i], 10) * (8 - i);
  }
  a %= 11;

  let c;
  if (a === 0) {
    c = 1;
  } else if (a === 1) {
    c = 0;
  } else {
    c = 11 - a;
  }

  return parseInt(companyId[7], 10) === c;
}

export function isValidSK(companyId: string): boolean {
  return /^[\d\w]{6,20}$/.test(companyId);
}

export function isValidTin(value: string | null | undefined): boolean {
  const { country } = getCountryConfig();
  if (!value) {
    return false;
  }
  switch (country) {
    case Country.CZECH_REPUBLIC:
      return isValidCZ(value);
    case Country.SLOVAKIA:
      return isValidSK(value);
    default:
      throw new Error(`Unsupported country`);
  }
}
